import files from './File/sagas';
import customers from './Customer/sagas';
import entities from './Entity/sagas';
import paginatedItems from './PaginatedItems/sagas';
import session from './Session/sagas';

export default [
  customers,
  entities,
  files,
  paginatedItems,
  session,
];
